import { render, staticRenderFns } from "./OnlineRowVideo.vue?vue&type=template&id=c2b81372&scoped=true"
import script from "./OnlineRowVideo.vue?vue&type=script&lang=js"
export * from "./OnlineRowVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b81372",
  null
  
)

export default component.exports